import { DefaultService } from '@/services/DefaultService';

export default class ExportacaoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }
    // Aqui já faz o update também, caso seja passado o id da exportacao o metodo identifica que é um update e atualiza os seguintes campos:
    // url = ?, datahoradisponivel = ?, datahoraexcluido = ?, situacao = ?
    save(exp) {
        return this._http.post(`${this._env}/export/save`, exp, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Erro ao salvar a exportação');
        });
    }

    
    delete(id) {
        return this._http.delete(`${this._env}/export/delete/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Erro ao deletar exportacao');
        });
    }

    downloadArchive(url){
        return this._http.get(`${this._env}${url}`, {responseType: 'arraybuffer'}).then(res => {
            return res;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(filtros, column, order, page = 0, limit = 50, ...params) {
        return this._http.post(encodeURI(`${this._env}/system/export.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), filtros, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findById(id) {
        return this._http.get(`${this._env}/system/export/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    enviarEmail(mail) {
        return this._http.post(`${this._env}/export/atendimento/sendmail.json`, mail, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}